<template>
  <div class="sign-contract-modal">
    <HMModalHeader
      :title="$t('CONTRACTS.TITLES.SIGN_CONTRACT')"
      :closable="false"
    />
    <div class="container mt-4">
      <div
        class="d-flex flex-row justify-content-start flex-wrap flex-md-nowrap"
      >
        <StudioProductCard
          v-if="!!signedContract.product"
          :product="signedContract.product"
          :animated="false"
          :static="true"
          size="sm"
          style="pointer-events: none; margin-right: 4rem"
        />
        <div>
          <h4 class="mb-5">
            {{ $t('CONTRACTS.TEXT.REVIEW_AND_SIGN_THE_CONTRACT') }}
          </h4>
          <SignContractComponent
            class="flex-grow-1"
            :signedContract="signedContract"
            @onContractSigned="$emit('close')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import SignContractComponent from './SignContractComponent';
import StudioProductCard from '@/web/components/products/StudioProductCard';

export default Vue.extend({
  name: 'SignContractModal',
  components: {
    SignContractComponent,
    StudioProductCard,
  },
  props: {
    signedContract: {
      type: Object,
    },
  },
});
</script>
